module.exports = __webpack_public_path__ + "img/HD_title_yyq_1_f42634b7e.png";